<template>
  <div>
    <b-card class="mb-4">
      <b-card-text>
        <h5 class="card-title">Solid Icons</h5>
        <b-row class="icons">
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-address-book"></em> fas
            fa-address-book
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-address-card"></em> fas
            fa-address-card
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-adjust"></em> fas fa-adjust
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-align-center"></em> fas
            fa-align-center
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-align-justify"></em> fas
            fa-align-justify
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-align-left"></em> fas
            fa-align-left
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-align-right"></em> fas
            fa-align-right
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-allergies"></em> fas fa-allergies
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-ambulance"></em> fas fa-ambulance
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em
              class="mr-2 text-truncate fas fa-american-sign-language-interpreting"
            ></em>
            fas fa-american-sign-language-interpreting
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-anchor"></em> fas fa-anchor
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-angle-double-down"></em> fas
            fa-angle-double-down
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-angle-double-left"></em> fas
            fa-angle-double-left
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-angle-double-right"></em> fas
            fa-angle-double-right
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-angle-double-up"></em> fas
            fa-angle-double-up
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-angle-down"></em> fas
            fa-angle-down
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-angle-left"></em> fas
            fa-angle-left
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-angle-right"></em> fas
            fa-angle-right
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-angle-up"></em> fas fa-angle-up
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-archive"></em> fas fa-archive
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-arrow-alt-circle-down"></em> fas
            fa-arrow-alt-circle-down
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-arrow-alt-circle-left"></em> fas
            fa-arrow-alt-circle-left
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-arrow-alt-circle-right"></em> fas
            fa-arrow-alt-circle-right
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-arrow-alt-circle-up"></em> fas
            fa-arrow-alt-circle-up
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-arrow-circle-down"></em> fas
            fa-arrow-circle-down
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-arrow-circle-left"></em> fas
            fa-arrow-circle-left
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-arrow-circle-right"></em> fas
            fa-arrow-circle-right
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-arrow-circle-up"></em> fas
            fa-arrow-circle-up
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-arrow-down"></em> fas
            fa-arrow-down
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-arrow-left"></em> fas
            fa-arrow-left
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-arrow-right"></em> fas
            fa-arrow-right
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-arrow-up"></em> fas fa-arrow-up
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-arrows-alt"></em> fas
            fa-arrows-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-arrows-alt-h"></em> fas
            fa-arrows-alt-h
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-arrows-alt-v"></em> fas
            fa-arrows-alt-v
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em
              class="mr-2 text-truncate fas fa-assistive-listening-systems"
            ></em>
            fas fa-assistive-listening-systems
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-asterisk"></em> fas fa-asterisk
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-at"></em> fas fa-at
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-audio-description"></em> fas
            fa-audio-tion
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-backward"></em> fas fa-backward
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-balance-scale"></em> fas
            fa-balance-scale
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-ban"></em> fas fa-ban
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-band-aid"></em> fas fa-band-aid
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-barcode"></em> fas fa-barcode
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-bars"></em> fas fa-bars
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-baseball-ball"></em> fas
            fa-baseball-ball
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-basketball-ball"></em> fas
            fa-basketba
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-bath"></em> fas fa-bath
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-battery-empty"></em> fas
            fa-battery-empty
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-battery-full"></em> fas
            fa-battery-full
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-battery-half"></em> fas
            fa-battery-half
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-battery-quarter"></em> fas
            fa-battery-quarter
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-battery-three-quarters"></em> fas
            fa-battery-three-quarters
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-bed"></em> fas fa-bed
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-beer"></em> fas fa-beer
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-bell"></em> fas fa-bell
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-bell-slash"></em> fas
            fa-bell-slash
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-bicycle"></em> fas fa-bicycle
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-binoculars"></em> fas
            fa-binoculars
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-birthday-cake"></em> fas
            fa-birthday-cake
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-blind"></em> fas fa-blind
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-bold"></em> fas fa-bold
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-bolt"></em> fas fa-bolt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-bomb"></em> fas fa-bomb
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-book"></em> fas fa-book
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-bookmark"></em> fas fa-bookmark
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-bowling-ball"></em> fas
            fa-bowling-ball
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-box"></em> fas fa-box
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-box-open"></em> fas fa-box-open
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-boxes"></em> fas fa-boxes
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-braille"></em> fas fa-braille
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-briefcase"></em> fas fa-briefcase
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-briefcase-medical"></em> fas
            fa-briefcical
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-bug"></em> fas fa-bug
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-building"></em> fas fa-building
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-bullhorn"></em> fas fa-bullhorn
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-bullseye"></em> fas fa-bullseye
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-burn"></em> fas fa-burn
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-bus"></em> fas fa-bus
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-calculator"></em> fas
            fa-calculator
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-calendar"></em> fas fa-calendar
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-calendar-alt"></em> fas
            fa-calendar-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-calendar-check"></em> fas
            fa-calendar-check
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-calendar-minus"></em> fas
            fa-calendar-minus
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-calendar-plus"></em> fas
            fa-calendar-plus
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-calendar-times"></em> fas
            fa-calendar-times
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-camera"></em> fas fa-camera
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-camera-retro"></em> fas
            fa-camera-retro
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-capsules"></em> fas fa-capsules
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-car"></em> fas fa-car
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-caret-down"></em> fas
            fa-caret-down
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-caret-left"></em> fas
            fa-caret-left
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-caret-right"></em> fas
            fa-caret-right
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-caret-square-down"></em> fas
            fa-caret-down
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-caret-square-left"></em> fas
            fa-caret-left
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-caret-square-right"></em> fas
            fa-caret-right
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-caret-square-up"></em> fas
            fa-caret-sq
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-caret-up"></em> fas fa-caret-up
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-cart-arrow-down"></em> fas
            fa-cart-arr
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-cart-plus"></em> fas fa-cart-plus
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-certificate"></em> fas
            fa-certificate
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chart-area"></em> fas
            fa-chart-area
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chart-bar"></em> fas fa-chart-bar
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chart-line"></em> fas
            fa-chart-line
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chart-pie"></em> fas fa-chart-pie
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-check"></em> fas fa-check
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-check-circle"></em> fas
            fa-check-circle
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-check-square"></em> fas
            fa-check-square
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chess"></em> fas fa-chess
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chess-bishop"></em> fas
            fa-chess-bishop
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chess-board"></em> fas
            fa-chess-board
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chess-king"></em> fas
            fa-chess-king
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chess-knight"></em> fas
            fa-chess-knight
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chess-pawn"></em> fas
            fa-chess-pawn
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chess-queen"></em> fas
            fa-chess-queen
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chess-rook"></em> fas
            fa-chess-rook
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chevron-circle-down"></em> fas
            fa-chevron-circle-down
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chevron-circle-left"></em> fas
            fa-chevron-circle-left
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chevron-circle-right"></em> fas
            fa-chevron-circle-right
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chevron-circle-up"></em> fas
            fa-chevroe-up
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chevron-down"></em> fas
            fa-chevron-down
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chevron-left"></em> fas
            fa-chevron-left
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chevron-right"></em> fas
            fa-chevron-right
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-chevron-up"></em> fas
            fa-chevron-up
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-child"></em> fas fa-child
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-circle"></em> fas fa-circle
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-circle-notch"></em> fas
            fa-circle-notch
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-clipboard"></em> fas fa-clipboard
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-clipboard-check"></em> fas
            fa-clipboard-check
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-clipboard-list"></em> fas
            fa-clipboard-list
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-clock"></em> fas fa-clock
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-clone"></em> fas fa-clone
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-closed-captioning"></em> fas
            fa-closedning
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-cloud"></em> fas fa-cloud
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-cloud-download-alt"></em> fas
            fa-cloudad-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-cloud-upload-alt"></em> fas
            fa-cloud-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-code"></em> fas fa-code
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-code-branch"></em> fas
            fa-code-branch
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-coffee"></em> fas fa-coffee
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-cog"></em> fas fa-cog
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-cogs"></em> fas fa-cogs
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-columns"></em> fas fa-columns
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-comment"></em> fas fa-comment
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-comment-alt"></em> fas
            fa-comment-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-comment-dots"></em> fas
            fa-comment-dots
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-comment-slash"></em> fas
            fa-comment-slash
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-comments"></em> fas fa-comments
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-compass"></em> fas fa-compass
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-compress"></em> fas fa-compress
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-copy"></em> fas fa-copy
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-copyright"></em> fas fa-copyright
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-couch"></em> fas fa-couch
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-credit-card"></em> fas
            fa-credit-card
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-crop"></em> fas fa-crop
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-crosshairs"></em> fas
            fa-crosshairs
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-cube"></em> fas fa-cube
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-cubes"></em> fas fa-cubes
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-cut"></em> fas fa-cut
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-database"></em> fas fa-database
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-deaf"></em> fas fa-deaf
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-desktop"></em> fas fa-desktop
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-diagnoses"></em> fas fa-diagnoses
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-dna"></em> fas fa-dna
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-dollar-sign"></em> fas
            fa-dollar-sign
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-dolly"></em> fas fa-dolly
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-dolly-flatbed"></em> fas
            fa-dolly-flatbed
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-donate"></em> fas fa-donate
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-dot-circle"></em> fas
            fa-dot-circle
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-dove"></em> fas fa-dove
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-download"></em> fas fa-download
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-edit"></em> fas fa-edit
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-eject"></em> fas fa-eject
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-ellipsis-h"></em> fas
            fa-ellipsis-h
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-ellipsis-v"></em> fas
            fa-ellipsis-v
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-envelope"></em> fas fa-envelope
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-envelope-open"></em> fas
            fa-envelope-open
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-envelope-square"></em> fas
            fa-envelope-square
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-eraser"></em> fas fa-eraser
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-euro-sign"></em> fas fa-euro-sign
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-exchange-alt"></em> fas
            fa-exchange-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-exclamation"></em> fas
            fa-exclamation
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-exclamation-circle"></em> fas
            fa-exclamation-circle
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-exclamation-triangle"></em> fas
            fa-exclamation-triangle
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-expand"></em> fas fa-expand
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-expand-arrows-alt"></em> fas
            fa-expand-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-external-link-alt"></em> fas
            fa-external-link-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-external-link-square-alt"></em>
            fas fa-external-link-square-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-eye"></em> fas fa-eye
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-eye-dropper"></em> fas
            fa-eye-dropper
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-eye-slash"></em> fas fa-eye-slash
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-fast-backward"></em> fas
            fa-fast-backward
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-fast-forward"></em> fas
            fa-fast-forward
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-fax"></em> fas fa-fax
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-female"></em> fas fa-female
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-fighter-jet"></em> fas
            fa-fighter-jet
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-file"></em> fas fa-file
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-file-alt"></em> fas fa-file-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-file-archive"></em> fas
            fa-file-archive
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-file-audio"></em> fas
            fa-file-audio
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-file-code"></em> fas fa-file-code
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-file-excel"></em> fas
            fa-file-excel
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-file-image"></em> fas
            fa-file-image
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-file-medical"></em> fas
            fa-file-medical
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-file-medical-alt"></em> fas
            fa-file-medical-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-file-pdf"></em> fas fa-file-pdf
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-file-powerpoint"></em> fas
            fa-file-pow
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-file-video"></em> fas
            fa-file-video
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-file-word"></em> fas fa-file-word
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-film"></em> fas fa-film
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-filter"></em> fas fa-filter
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-fire"></em> fas fa-fire
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-fire-extinguisher"></em> fas
            fa-fire-extinguisher
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-first-aid"></em> fas fa-first-aid
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-flag"></em> fas fa-flag
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-flag-checkered"></em> fas
            fa-flag-checkered
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-flask"></em> fas fa-flask
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-folder"></em> fas fa-folder
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-folder-open"></em> fas
            fa-folder-open
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-font"></em> fas fa-font
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-football-ball"></em> fas
            fa-football-ball
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-forward"></em> fas fa-forward
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-frown"></em> fas fa-frown
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-futbol"></em> fas fa-futbol
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-gamepad"></em> fas fa-gamepad
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-gavel"></em> fas fa-gavel
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-gem"></em> fas fa-gem
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-genderless"></em> fas
            fa-genderless
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-gift"></em> fas fa-gift
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-glass-martini"></em> fas
            fa-glass-martini
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-globe"></em> fas fa-globe
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-golf-ball"></em> fas fa-golf-ball
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-graduation-cap"></em> fas
            fa-graduation-cap
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-h-square"></em> fas fa-h-square
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hand-holding"></em> fas
            fa-hand-holding
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hand-holding-heart"></em> fas
            fa-hand-holding-heart
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hand-holding-usd"></em> fas
            fa-hand-holding-usd
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hand-lizard"></em> fas
            fa-hand-lizard
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hand-paper"></em> fas
            fa-hand-paper
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hand-peace"></em> fas
            fa-hand-peace
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hand-point-down"></em> fas
            fa-hand-point-down
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hand-point-left"></em> fas
            fa-hand-point-left
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hand-point-right"></em> fas
            fa-hand-point-right
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hand-point-up"></em> fas
            fa-hand-point-up
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hand-pointer"></em> fas
            fa-hand-pointer
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hand-rock"></em> fas fa-hand-rock
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hand-scissors"></em> fas
            fa-hand-scissors
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hand-spock"></em> fas
            fa-hand-spock
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hands"></em> fas fa-hands
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hands-helping"></em> fas
            fa-hands-helping
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-handshake"></em> fas fa-handshake
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hashtag"></em> fas fa-hashtag
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hdd"></em> fas fa-hdd
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-heading"></em> fas fa-heading
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-headphones"></em> fas
            fa-headphones
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-heart"></em> fas fa-heart
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-heartbeat"></em> fas fa-heartbeat
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-history"></em> fas fa-history
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hockey-puck"></em> fas
            fa-hockey-puck
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-home"></em> fas fa-home
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hospital"></em> fas fa-hospital
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hospital-alt"></em> fas
            fa-hospital-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hospital-symbol"></em> fas
            fa-hospital
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hourglass"></em> fas fa-hourglass
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hourglass-end"></em> fas
            fa-hourglass-end
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hourglass-half"></em> fas
            fa-hourglass-half
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-hourglass-start"></em> fas
            fa-hourglass-start
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-i-cursor"></em> fas fa-i-cursor
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-id-badge"></em> fas fa-id-badge
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-id-card"></em> fas fa-id-card
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-id-card-alt"></em> fas
            fa-id-card-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-image"></em> fas fa-image
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-images"></em> fas fa-images
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-inbox"></em> fas fa-inbox
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-indent"></em> fas fa-indent
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-industry"></em> fas fa-industry
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-info"></em> fas fa-info
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-info-circle"></em> fas
            fa-info-circle
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-italic"></em> fas fa-italic
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-key"></em> fas fa-key
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-keyboard"></em> fas fa-keyboard
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-language"></em> fas fa-language
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-laptop"></em> fas fa-laptop
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-leaf"></em> fas fa-leaf
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-lemon"></em> fas fa-lemon
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-level-down-alt"></em> fas
            fa-level-down-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-level-up-alt"></em> fas
            fa-level-up-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-life-ring"></em> fas fa-life-ring
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-lightbulb"></em> fas fa-lightbulb
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-link"></em> fas fa-link
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-lira-sign"></em> fas fa-lira-sign
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-list"></em> fas fa-list
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-list-alt"></em> fas fa-list-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-list-ol"></em> fas fa-list-ol
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-list-ul"></em> fas fa-list-ul
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-location-arrow"></em> fas
            fa-location-arrow
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-lock"></em> fas fa-lock
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-lock-open"></em> fas fa-lock-open
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-long-arrow-alt-down"></em> fas
            fa-long-arrow-alt-down
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-long-arrow-alt-left"></em> fas
            fa-long-arrow-alt-left
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-long-arrow-alt-right"></em> fas
            fa-long-arrow-alt-right
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-long-arrow-alt-up"></em> fas
            fa-long-arrow-alt-up
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-low-vision"></em> fas
            fa-low-vision
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-magic"></em> fas fa-magic
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-magnet"></em> fas fa-magnet
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-male"></em> fas fa-male
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-map"></em> fas fa-map
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-map-marker"></em> fas
            fa-map-marker
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-map-marker-alt"></em> fas
            fa-map-marker-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-map-pin"></em> fas fa-map-pin
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-map-signs"></em> fas fa-map-signs
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-mars"></em> fas fa-mars
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-mars-double"></em> fas
            fa-mars-double
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-mars-stroke"></em> fas
            fa-mars-stroke
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-mars-stroke-h"></em> fas
            fa-mars-stroke-h
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-mars-stroke-v"></em> fas
            fa-mars-stroke-v
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-medkit"></em> fas fa-medkit
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-meh"></em> fas fa-meh
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-mercury"></em> fas fa-mercury
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-microchip"></em> fas fa-microchip
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-microphone"></em> fas
            fa-microphone
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-microphone-slash"></em> fas
            fa-microphone-slash
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-minus"></em> fas fa-minus
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-minus-circle"></em> fas
            fa-minus-circle
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-minus-square"></em> fas
            fa-minus-square
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-mobile"></em> fas fa-mobile
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-mobile-alt"></em> fas
            fa-mobile-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-money-bill-alt"></em> fas
            money-bill-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-moon"></em> fas fa-moon
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-motorcycle"></em> fas
            fa-motorcycle
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-mouse-pointer"></em> fas
            fa-mouse-pointer
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-music"></em> fas fa-music
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-neuter"></em> fas fa-neuter
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-newspaper"></em> fas fa-newspaper
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-notes-medical"></em> fas
            fa-notes-medical
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-object-group"></em> fas
            fa-object-group
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-object-ungroup"></em> fas
            fa-object-ungroup
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-outdent"></em> fas fa-outdent
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-paint-brush"></em> fas
            fa-paint-brush
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-pallet"></em> fas fa-pallet
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-paper-plane"></em> fas
            fa-paper-plane
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-paperclip"></em> fas fa-paperclip
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-parachute-box"></em> fas
            fa-parachute-box
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-paragraph"></em> fas fa-paragraph
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-paste"></em> fas fa-paste
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-pause"></em> fas fa-pause
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-pause-circle"></em> fas
            pause-circle
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-paw"></em> fas fa-fa-paw
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-pen-square"></em> fas
            fa-pen-square
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-pencil-alt"></em> fas
            fa-pencil-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-people-carry"></em> fas
            fa-people-carry
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-percent"></em> fas fa-percent
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-phone"></em> fas fa-phone
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-phone-slash"></em> fas
            fa-phone-slash
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-phone-square"></em> fas
            fa-phone-square
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-phone-volume"></em> fas
            fa-phone-volume
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-piggy-bank"></em> fas
            fa-piggy-bank
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-pills"></em> fas fa-pills
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-plane"></em> fas fa-plane
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-play"></em> fas fa-play
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-play-circle"></em> fas
            fa-play-circle
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-plug"></em> fas fa-plug
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-plus"></em> fas fa-plus
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-plus-circle"></em> fas
            fa-plus-circle
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-plus-square"></em> fas
            fa-plus-square
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-podcast"></em> fas fa-podcast
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-poo"></em> fas fa-poo
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-pound-sign"></em> fas
            fa-pound-sign
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-power-off"></em> fas fa-power-off
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-prescription-bottle"></em> fas
            fa-prescription-bottle
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-prescription-bottle-alt"></em>
            fas fa-prescription-bottle-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-print"></em> fas fa-print
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-procedures"></em> fas
            fa-procedures
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-puzzle-piece"></em> fas
            fa-puzzle-piece
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-qrcode"></em> fas fa-qrcode
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-question"></em> fas fa-question
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-question-circle"></em> fas
            fa-question
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-quidditch"></em> fas fa-quidditch
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-quote-left"></em> fas
            fa-quote-left
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-quote-right"></em> fas
            fa-quote-right
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-random"></em> fas fa-random
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-recycle"></em> fas fa-recycle
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-redo"></em> fas fa-redo
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-redo-alt"></em> fas fa-redo-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-registered"></em> fas
            fa-registered
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-reply"></em> fas fa-reply
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-reply-all"></em> fas fa-reply-all
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-retweet"></em> fas fa-retweet
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-ribbon"></em> fas fa-ribbon
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-road"></em> fas fa-road
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-rocket"></em> fas fa-rocket
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-rss"></em> fas fa-rss
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-rss-square"></em> fas
            fa-rss-square
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-ruble-sign"></em> fas
            fa-ruble-sign
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-rupee-sign"></em> fas
            fa-rupee-sign
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-save"></em> fas fa-save
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-search"></em> fas fa-search
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-search-minus"></em> fas
            fa-search-minus
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-search-plus"></em> fas
            fa-search-plus
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-seedling"></em> fas fa-seedling
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-server"></em> fas fa-server
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-share"></em> fas fa-share
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-share-alt"></em> fas fa-share-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-share-alt-square"></em> fas
            fa-share-alt-square
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-share-square"></em> fas
            fa-share-square
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-shekel-sign"></em> fas
            fa-shekel-sign
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-shield-alt"></em> fas
            fa-shield-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-ship"></em> fas fa-ship
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-shipping-fast"></em> fas
            fa-shipping-fast
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-shopping-bag"></em> fas
            fa-shopping-bag
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-shopping-basket"></em> fas
            fa-shopping-basket
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-shopping-cart"></em> fas
            fa-shopping-cart
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-shower"></em> fas fa-shower
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-sign"></em> fas fa-sign
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-sign-in-alt"></em> fas
            fa-sign-in-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-sign-language"></em> fas
            fa-sign-language
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-sign-out-alt"></em> fas
            fa-sign-out-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-signal"></em> fas fa-signal
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-sitemap"></em> fas fa-sitemap
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-sliders-h"></em> fas fa-sliders-h
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-smile"></em> fas fa-smile
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-smoking"></em> fas fa-smoking
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-snowflake"></em> fas fa-snowflake
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-sort"></em> fas fa-sort
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-sort-alpha-down"></em> fas
            fa-alpha-down
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-sort-alpha-up"></em> fas
            fa-sort-alpha-up
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-sort-amount-down"></em> fas
            fa-sort-amount-down
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-sort-amount-up"></em> fas
            fa-sort-amount-up
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-sort-down"></em> fas fa-sort-down
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-sort-numeric-down"></em> fas
            fa-sort-numeric-down
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-sort-numeric-up"></em> fas
            fa-sort-numeric-up
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-sort-up"></em> fas fa-sort-up
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-space-shuttle"></em> fas
            fa-space-shuttle
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-spinner"></em> fas fa-spinner
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-square"></em> fas fa-square
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-square-full"></em> fas
            fa-square-full
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-star"></em> fas fa-star
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-star-half"></em> fas fa-star-half
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-step-backward"></em> fas
            fa-step-backward
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-step-forward"></em> fas
            fa-step-forward
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-stethoscope"></em> fas
            fa-stethoscope
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-sticky-note"></em> fas
            fa-sticky-note
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-stop"></em> fas fa-stop
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-stop-circle"></em> fas
            fa-stop-circle
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-stopwatch"></em> fas fa-stopwatch
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-street-view"></em> fas
            fa-street-view
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-strikethrough"></em> fas
            fa-strikethrough
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-subscript"></em> fas fa-subscript
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-subway"></em> fas fa-subway
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-suitcase"></em> fas fa-suitcase
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-sun"></em> fas fa-sun
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-superscript"></em> fas
            fa-superscript
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-sync"></em> fas fa-sync
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-sync-alt"></em> fas fa-sync-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-syringe"></em> fas fa-syringe
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-table"></em> fas fa-table
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-table-tennis"></em> fas
            fa-table-tennis
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-tablet"></em> fas fa-tablet
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-tablet-alt"></em> fas
            fa-tablet-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-tablets"></em> fas fa-tablets
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-tachometer-alt"></em> fas
            fa-tachometer-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-tag"></em> fas fa-tag
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-tags"></em> fas fa-tags
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-tape"></em> fas fa-tape
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-tasks"></em> fas fa-tasks
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-taxi"></em> fas fa-taxi
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-terminal"></em> fas fa-terminal
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-text-height"></em> fas
            fa-text-height
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-text-width"></em> fas
            fa-text-width
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-th"></em> fas fa-th
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-th-large"></em> fas fa-th-large
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-th-list"></em> fas fa-th-list
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-thermometer"></em> fas
            fa-thermometer
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-thermometer-empty"></em> fas
            fa-thermometer-empty
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-thermometer-full"></em> fas
            fa-thermometer-full
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-thermometer-half"></em> fas
            fa-thermometer-half
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-thermometer-quarter"></em> fas
            fa-thermometer-quarter
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-thermometer-three-quarters"></em>
            fas fa-thermometer-three-quarters
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-thumbs-down"></em> fas
            fa-thumbs-down
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-thumbs-up"></em> fas fa-thumbs-up
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-thumbtack"></em> fas fa-thumbtack
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-ticket-alt"></em> fas
            fa-ticket-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-times"></em> fas fa-times
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-times-circle"></em> fas
            fa-times-circle
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-tint"></em> fas fa-tint
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-toggle-off"></em> fas
            fa-toggle-off
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-toggle-on"></em> fas fa-toggle-on
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-trademark"></em> fas fa-trademark
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-train"></em> fas fa-train
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-transgender"></em> fas
            fa-transgender
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-transgender-alt"></em> fas
            fa-transgen
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-trash"></em> fas fa-trash
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-trash-alt"></em> fas fa-trash-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-tree"></em> fas fa-tree
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-trophy"></em> fas fa-trophy
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-truck"></em> fas fa-truck
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-truck-loading"></em> fas
            fa-truck-loading
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-truck-moving"></em> fas
            fa-truck-moving
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-tty"></em> fas fa-tty
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-tv"></em> fas fa-tv
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-umbrella"></em> fas fa-umbrella
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-underline"></em> fas fa-underline
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-undo"></em> fas fa-undo
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-undo-alt"></em> fas fa-undo-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-universal-access"></em> fas
            fa-universal-access
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-university"></em> fas
            fa-university
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-unlink"></em> fas fa-unlink
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-unlock"></em> fas fa-unlock
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-unlock-alt"></em> fas
            fa-unlock-alt
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-upload"></em> fas fa-upload
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-user"></em> fas fa-user
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-user-circle"></em> fas
            fa-user-circle
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-user-md"></em> fas fa-user-md
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-user-plus"></em> fas fa-user-plus
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-user-secret"></em> fas
            fa-user-secret
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-user-times"></em> fas
            fa-user-times
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-users"></em> fas fa-users
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-utensil-spoon"></em> fas
            fa-utensil-spoon
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-utensils"></em> fas fa-utensils
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-venus"></em> fas fa-venus
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-venus-double"></em> fas
            fa-venus-double
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-venus-mars"></em> fas
            fa-venus-mars
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-vial"></em> fas fa-vial
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-vials"></em> fas fa-vials
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-video"></em> fas fa-video
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-video-slash"></em> fas
            fa-video-slash
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-volleyball-ball"></em> fas
            fa-volleyba
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-volume-down"></em> fas
            fa-volume-down
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-volume-off"></em> fas
            fa-volume-off
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-volume-up"></em> fas fa-volume-up
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-warehouse"></em> fas fa-warehouse
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-weight"></em> fas fa-weight
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-wheelchair"></em> fas
            fa-wheelchair
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-wifi"></em> fas fa-wifi
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-window-close"></em> fas
            fa-window-close
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-window-maximize"></em> fas
            fa-window-maximize
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-window-minimize"></em> fas
            fa-window-minimize
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-window-restore"></em> fas
            fa-window-restore
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-wine-glass"></em> fas
            fa-wine-glass
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-won-sign"></em> fas fa-won-sign
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-wrench"></em> fas fa-wrench
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-x-ray"></em> fas fa-x-ray
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 text-truncate fas fa-yen-sign"></em> fas fa-yen-sign
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
    <b-card class="mb-4">
      <b-card-text>
        <h5 class="card-title">Regular Icons</h5>
        <b-row class="icons">
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-address-book"></em>
            <span>far fa-address-book</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-address-card"></em>
            <span>far fa-address-card</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-arrow-alt-circle-down"></em>
            <span>far fa-arrow-alt-circle-down</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-arrow-alt-circle-left"></em>
            <span>far fa-arrow-alt-circle-left</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-arrow-alt-circle-right"></em>
            <span>far fa-arrow-alt-circle-right</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-arrow-alt-circle-up"></em>
            <span>far fa-arrow-alt-circle-up</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-bell"></em>
            <span>far fa-bell</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-bell-slash"></em>
            <span>far fa-bell-slash</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-bookmark"></em>
            <span>far fa-bookmark</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-building"></em>
            <span>far fa-building</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-calendar"></em>
            <span>far fa-calendar</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-calendar-alt"></em>
            <span>far fa-calendar-alt</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-calendar-check"></em>
            <span>far fa-calendar-check</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-calendar-minus"></em>
            <span>far fa-calendar-minus</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-calendar-plus"></em>
            <span>far fa-calendar-plus</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-calendar-times"></em>
            <span>far fa-calendar-times</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-caret-square-down"></em>
            <span>far fa-caret-square-down</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-caret-square-left"></em>
            <span>far fa-caret-square-left</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-caret-square-right"></em>
            <span>far fa-caret-square-right</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-caret-square-up"></em>
            <span>far fa-caret-square-up</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-chart-bar"></em>
            <span>far fa-chart-bar</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-check-circle"></em>
            <span>far fa-check-circle</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-check-square"></em>
            <span>far fa-check-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-circle"></em>
            <span>far fa-circle</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-clipboard"></em>
            <span>far fa-clipboard</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-clock"></em>
            <span>far fa-clock</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-clone"></em>
            <span>far fa-clone</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-closed-captioning"></em>
            <span>far fa-closed-captioning</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-comment"></em>
            <span>far fa-comment</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-comment-alt"></em>
            <span>far fa-comment-alt</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-comments"></em>
            <span>far fa-comments</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-compass"></em>
            <span>far fa-compass</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-copy"></em>
            <span>far fa-copy</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-copyright"></em>
            <span>far fa-copyright</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-credit-card"></em>
            <span>far fa-credit-card</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-dot-circle"></em>
            <span>far fa-dot-circle</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-edit"></em>
            <span>far fa-edit</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-envelope"></em>
            <span>far fa-envelope</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-envelope-open"></em>
            <span>far fa-envelope-open</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-eye-slash"></em>
            <span>far fa-eye-slash</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-file"></em>
            <span>far fa-file</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-file-alt"></em>
            <span>far fa-file-alt</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-file-archive"></em>
            <span>far fa-file-archive</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-file-audio"></em>
            <span>far fa-file-audio</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-file-code"></em>
            <span>far fa-file-code</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-file-excel"></em>
            <span>far fa-file-excel</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-file-image"></em>
            <span>far fa-file-image</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-file-pdf"></em>
            <span>far fa-file-pdf</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-file-powerpoint"></em>
            <span>far fa-file-powerpoint</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-file-video"></em>
            <span>far fa-file-video</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-file-word"></em>
            <span>far fa-file-word</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-flag"></em>
            <span>far fa-flag</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-folder"></em>
            <span>far fa-folder</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-folder-open"></em>
            <span>far fa-folder-open</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-frown"></em>
            <span>far fa-frown</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-futbol"></em>
            <span>far fa-futbol</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-gem"></em>
            <span>far fa-gem</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-hand-lizard"></em>
            <span>far fa-hand-lizard</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-hand-paper"></em>
            <span>far fa-hand-paper</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-hand-peace"></em>
            <span>far fa-hand-peace</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-hand-point-down"></em>
            <span>far fa-hand-point-down</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-hand-point-left"></em>
            <span>far fa-hand-point-left</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-hand-point-right"></em>
            <span>far fa-hand-point-right</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-hand-point-up"></em>
            <span>far fa-hand-point-up</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-hand-pointer"></em>
            <span>far fa-hand-pointer</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-hand-rock"></em>
            <span>far fa-hand-rock</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-hand-scissors"></em>
            <span>far fa-hand-scissors</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-hand-spock"></em>
            <span>far fa-hand-spock</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-handshake"></em>
            <span>far fa-handshake</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-hdd"></em>
            <span>far fa-hdd</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-heart"></em>
            <span>far fa-heart</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-hospital"></em>
            <span>far fa-hospital</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-hourglass"></em>
            <span>far fa-hourglass</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-id-badge"></em>
            <span>far fa-id-badge</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-id-card"></em>
            <span>far fa-id-card</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-image"></em>
            <span>far fa-image</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-images"></em>
            <span>far fa-images</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-keyboard"></em>
            <span>far fa-keyboard</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-lemon"></em>
            <span>far fa-lemon</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-life-ring"></em>
            <span>far fa-life-ring</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-lightbulb"></em>
            <span>far fa-lightbulb</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-list-alt"></em>
            <span>far fa-list-alt</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-map"></em>
            <span>far fa-map</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-meh"></em>
            <span>far fa-meh</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-minus-square"></em>
            <span>far fa-minus-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-money-bill-alt"></em>
            <span>far fa-money-bill-alt</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-moon"></em>
            <span>far fa-moon</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-newspaper"></em>
            <span>far fa-newspaper</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-object-group"></em>
            <span>far fa-object-group</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-object-ungroup"></em>
            <span>far fa-object-ungroup</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-paper-plane"></em>
            <span>far fa-paper-plane</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-pause-circle"></em>
            <span>far fa-pause-circle</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-play-circle"></em>
            <span>far fa-play-circle</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-plus-square"></em>
            <span>far fa-plus-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-question-circle"></em>
            <span>far fa-question-circle</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-registered"></em>
            <span>far fa-registered</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-save"></em>
            <span>far fa-save</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-share-square"></em>
            <span>far fa-share-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-smile"></em>
            <span>far fa-smile</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-snowflake"></em>
            <span>far fa-snowflake</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-square"></em>
            <span>far fa-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-star"></em>
            <span>far fa-star</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-star-half"></em>
            <span>far fa-star-half</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-sticky-note"></em>
            <span>far fa-sticky-note</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-stop-circle"></em>
            <span>far fa-stop-circle</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-sun"></em>
            <span>far fa-sun</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-thumbs-down"></em>
            <span>far fa-thumbs-down</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-thumbs-up"></em>
            <span>far fa-thumbs-up</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-times-circle"></em>
            <span>far fa-times-circle</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-trash-alt"></em>
            <span>far fa-trash-alt</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-user"></em>
            <span>far fa-user</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-user-circle"></em>
            <span>far fa-user-circle</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-window-close"></em>
            <span>far fa-window-close</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-window-maximize"></em>
            <span>far fa-window-maximize</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-window-minimize"></em>
            <span>far fa-window-minimize</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 far fa-window-restore"></em>
            <span>far fa-window-restore</span>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
    <b-card class="mb-4">
      <b-card-text>
        <h5 class="card-title">Brand Icons</h5>
        <b-row class="icons">
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-500px"></em>
            <span>fab fa-500px</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-accessible-icon"></em>
            <span>fab fa-accessible-icon</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-accusoft"></em>
            <span>fab fa-accusoft</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-adn"></em>
            <span>fab fa-adn</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-adversal"></em>
            <span>fab fa-adversal</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-affiliatetheme"></em>
            <span>fab fa-affiliatetheme</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-algolia"></em>
            <span>fab fa-algolia</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-amazon"></em>
            <span>fab fa-amazon</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-amazon-pay"></em>
            <span>fab fa-amazon-pay</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-amilia"></em>
            <span>fab fa-amilia</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-android"></em>
            <span>fab fa-android</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-angellist"></em>
            <span>fab fa-angellist</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-angrycreative"></em>
            <span>fab fa-angrycreative</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-angular"></em>
            <span>fab fa-angular</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-app-store"></em>
            <span>fab fa-app-store</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-app-store-ios"></em>
            <span>fab fa-app-store-ios</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-apper"></em>
            <span>fab fa-apper</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-apple"></em>
            <span>fab fa-apple</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-apple-pay"></em>
            <span>fab fa-apple-pay</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-asymmetrik"></em>
            <span>fab fa-asymmetrik</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-audible"></em>
            <span>fab fa-audible</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-autoprefixer"></em>
            <span>fab fa-autoprefixer</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-avianex"></em>
            <span>fab fa-avianex</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-aviato"></em>
            <span>fab fa-aviato</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-aws"></em>
            <span>fab fa-aws</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-bandcamp"></em>
            <span>fab fa-bandcamp</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-behance"></em>
            <span>fab fa-behance</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-behance-square"></em>
            <span>fab fa-behance-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-bimobject"></em>
            <span>fab fa-bimobject</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-bitbucket"></em>
            <span>fab fa-bitbucket</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-bitcoin"></em>
            <span>fab fa-bitcoin</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-bity"></em>
            <span>fab fa-bity</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-black-tie"></em>
            <span>fab fa-black-tie</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-blackberry"></em>
            <span>fab fa-blackberry</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-blogger"></em>
            <span>fab fa-blogger</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-blogger-b"></em>
            <span>fab fa-blogger-b</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-bluetooth"></em>
            <span>fab fa-bluetooth</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-bluetooth-b"></em>
            <span>fab fa-bluetooth-b</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-btc"></em>
            <span>fab fa-btc</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-buromobelexperte"></em>
            <span>fab fa-buromobelexperte</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-cc-amazon-pay"></em>
            <span>fab fa-cc-amazon-pay</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-cc-amex"></em>
            <span>fab fa-cc-amex</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-cc-apple-pay"></em>
            <span>fab fa-cc-apple-pay</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-cc-diners-club"></em>
            <span>fab fa-cc-diners-club</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-cc-discover"></em>
            <span>fab fa-cc-discover</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-cc-jcb"></em>
            <span>fab fa-cc-jcb</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-cc-mastercard"></em>
            <span>fab fa-cc-mastercard</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-cc-paypal"></em>
            <span>fab fa-cc-paypal</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-cc-stripe"></em>
            <span>fab fa-cc-stripe</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-cc-visa"></em>
            <span>fab fa-cc-visa</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-centercode"></em>
            <span>fab fa-centercode</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-chrome"></em>
            <span>fab fa-chrome</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-cloudscale"></em>
            <span>fab fa-cloudscale</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-cloudsmith"></em>
            <span>fab fa-cloudsmith</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-cloudversify"></em>
            <span>fab fa-cloudversify</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-codepen"></em>
            <span>fab fa-codepen</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-codiepie"></em>
            <span>fab fa-codiepie</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-connectdevelop"></em>
            <span>fab fa-connectdevelop</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-contao"></em>
            <span>fab fa-contao</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-cpanel"></em>
            <span>fab fa-cpanel</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-creative-commons"></em>
            <span>fab fa-creative-commons</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-css3"></em>
            <span>fab fa-css3</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-css3-alt"></em>
            <span>fab fa-css3-alt</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-cuttlefish"></em>
            <span>fab fa-cuttlefish</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-d-and-d"></em>
            <span>fab fa-d-and-d</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-dashcube"></em>
            <span>fab fa-dashcube</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-delicious"></em>
            <span>fab fa-delicious</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-deploydog"></em>
            <span>fab fa-deploydog</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-deskpro"></em>
            <span>fab fa-deskpro</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-deviantart"></em>
            <span>fab fa-deviantart</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-digg"></em>
            <span>fab fa-digg</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-digital-ocean"></em>
            <span>fab fa-digital-ocean</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-discord"></em>
            <span>fab fa-discord</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-discourse"></em>
            <span>fab fa-discourse</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-dochub"></em>
            <span>fab fa-dochub</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-docker"></em>
            <span>fab fa-docker</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-draft2digital"></em>
            <span>fab fa-draft2digital</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-dribbble"></em>
            <span>fab fa-dribbble</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-dribbble-square"></em>
            <span>fab fa-dribbble-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-dropbox"></em>
            <span>fab fa-dropbox</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-drupal"></em>
            <span>fab fa-drupal</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-dyalog"></em>
            <span>fab fa-dyalog</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-earlybirds"></em>
            <span>fab fa-earlybirds</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-edge"></em>
            <span>fab fa-edge</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-elementor"></em>
            <span>fab fa-elementor</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-ember"></em>
            <span>fab fa-ember</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-empire"></em>
            <span>fab fa-empire</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-envira"></em>
            <span>fab fa-envira</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-erlang"></em>
            <span>fab fa-erlang</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-ethereum"></em>
            <span>fab fa-ethereum</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-etsy"></em>
            <span>fab fa-etsy</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-expeditedssl"></em>
            <span>fab fa-expeditedssl</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-facebook"></em>
            <span>fab fa-facebook</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-facebook-f"></em>
            <span>fab fa-facebook-f</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-facebook-messenger"></em>
            <span>fab fa-facebook-messenger</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-facebook-square"></em>
            <span>fab fa-facebook-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-firefox"></em>
            <span>fab fa-firefox</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-first-order"></em>
            <span>fab fa-first-order</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-firstdraft"></em>
            <span>fab fa-firstdraft</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-flickr"></em>
            <span>fab fa-flickr</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-flipboard"></em>
            <span>fab fa-flipboard</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-fly"></em>
            <span>fab fa-fly</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-font-awesome"></em>
            <span>fab fa-font-awesome</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-font-awesome-alt"></em>
            <span>fab fa-font-awesome-alt</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-font-awesome-flag"></em>
            <span>fab fa-font-awesome-flag</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-fonticons"></em>
            <span>fab fa-fonticons</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-fonticons-fi"></em>
            <span>fab fa-fonticons-fi</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-fort-awesome"></em>
            <span>fab fa-fort-awesome</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-fort-awesome-alt"></em>
            <span>fab fa-fort-awesome-alt</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-forumbee"></em>
            <span>fab fa-forumbee</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-foursquare"></em>
            <span>fab fa-foursquare</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-free-code-camp"></em>
            <span>fab fa-free-code-camp</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-freebsd"></em>
            <span>fab fa-freebsd</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-get-pocket"></em>
            <span>fab fa-get-pocket</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-gg"></em>
            <span>fab fa-gg</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-gg-circle"></em>
            <span>fab fa-gg-circle</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-git"></em>
            <span>fab fa-git</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-git-square"></em>
            <span>fab fa-git-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-github"></em>
            <span>fab fa-github</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-github-alt"></em>
            <span>fab fa-github-alt</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-github-square"></em>
            <span>fab fa-github-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-gitkraken"></em>
            <span>fab fa-gitkraken</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-gitlab"></em>
            <span>fab fa-gitlab</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-gitter"></em>
            <span>fab fa-gitter</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-glide"></em>
            <span>fab fa-glide</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-glide-g"></em>
            <span>fab fa-glide-g</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-gofore"></em>
            <span>fab fa-gofore</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-goodreads"></em>
            <span>fab fa-goodreads</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-goodreads-g"></em>
            <span>fab fa-goodreads-g</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-google"></em>
            <span>fab fa-google</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-google-drive"></em>
            <span>fab fa-google-drive</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-google-play"></em>
            <span>fab fa-google-play</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-google-plus"></em>
            <span>fab fa-google-plus</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-google-plus-g"></em>
            <span>fab fa-google-plus-g</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-google-plus-square"></em>
            <span>fab fa-google-plus-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-google-wallet"></em>
            <span>fab fa-google-wallet</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-gratipay"></em>
            <span>fab fa-gratipay</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-grav"></em>
            <span>fab fa-grav</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-gripfire"></em>
            <span>fab fa-gripfire</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-grunt"></em>
            <span>fab fa-grunt</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-gulp"></em>
            <span>fab fa-gulp</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-hacker-news"></em>
            <span>fab fa-hacker-news</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-hacker-news-square"></em>
            <span>fab fa-hacker-news-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-hips"></em>
            <span>fab fa-hips</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-hire-a-helper"></em>
            <span>fab fa-hire-a-helper</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-hooli"></em>
            <span>fab fa-hooli</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-hotjar"></em>
            <span>fab fa-hotjar</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-houzz"></em>
            <span>fab fa-houzz</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-html5"></em>
            <span>fab fa-html5</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-hubspot"></em>
            <span>fab fa-hubspot</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-imdb"></em>
            <span>fab fa-imdb</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-instagram"></em>
            <span>fab fa-instagram</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-internet-explorer"></em>
            <span>fab fa-internet-explorer</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-ioxhost"></em>
            <span>fab fa-ioxhost</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-itunes"></em>
            <span>fab fa-itunes</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-itunes-note"></em>
            <span>fab fa-itunes-note</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-jenkins"></em>
            <span>fab fa-jenkins</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-joget"></em>
            <span>fab fa-joget</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-joomla"></em>
            <span>fab fa-joomla</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-js"></em>
            <span>fab fa-js</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-js-square"></em>
            <span>fab fa-js-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-jsfiddle"></em>
            <span>fab fa-jsfiddle</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-keycdn"></em>
            <span>fab fa-keycdn</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-kickstarter"></em>
            <span>fab fa-kickstarter</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-kickstarter-k"></em>
            <span>fab fa-kickstarter-k</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-korvue"></em>
            <span>fab fa-korvue</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-laravel"></em>
            <span>fab fa-laravel</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-lastfm"></em>
            <span>fab fa-lastfm</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-lastfm-square"></em>
            <span>fab fa-lastfm-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-leanpub"></em>
            <span>fab fa-leanpub</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-less"></em>
            <span>fab fa-less</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-line"></em>
            <span>fab fa-line</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-linkedin"></em>
            <span>fab fa-linkedin</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-linkedin-in"></em>
            <span>fab fa-linkedin-in</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-linode"></em>
            <span>fab fa-linode</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-linux"></em>
            <span>fab fa-linux</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-lyft"></em>
            <span>fab fa-lyft</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-magento"></em>
            <span>fab fa-magento</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-maxcdn"></em>
            <span>fab fa-maxcdn</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-medapps"></em>
            <span>fab fa-medapps</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-medium"></em>
            <span>fab fa-medium</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-medium-m"></em>
            <span>fab fa-medium-m</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-medrt"></em>
            <span>fab fa-medrt</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-meetup"></em>
            <span>fab fa-meetup</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-microsoft"></em>
            <span>fab fa-microsoft</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-mix"></em>
            <span>fab fa-mix</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-mixcloud"></em>
            <span>fab fa-mixcloud</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-mizuni"></em>
            <span>fab fa-mizuni</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-modx"></em>
            <span>fab fa-modx</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-monero"></em>
            <span>fab fa-monero</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-napster"></em>
            <span>fab fa-napster</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-nintendo-switch"></em>
            <span>fab fa-nintendo-switch</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-node"></em>
            <span>fab fa-node</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-node-js"></em>
            <span>fab fa-node-js</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-npm"></em>
            <span>fab fa-npm</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-ns8"></em>
            <span>fab fa-ns8</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-nutritionix"></em>
            <span>fab fa-nutritionix</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-odnoklassniki"></em>
            <span>fab fa-odnoklassniki</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-odnoklassniki-square"></em>
            <span>fab fa-odnoklassniki-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-opencart"></em>
            <span>fab fa-opencart</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-openid"></em>
            <span>fab fa-openid</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-opera"></em>
            <span>fab fa-opera</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-optin-monster"></em>
            <span>fab fa-optin-monster</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-osi"></em>
            <span>fab fa-osi</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-page4"></em>
            <span>fab fa-page4</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-pagelines"></em>
            <span>fab fa-pagelines</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-palfed"></em>
            <span>fab fa-palfed</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-patreon"></em>
            <span>fab fa-patreon</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-paypal"></em>
            <span>fab fa-paypal</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-periscope"></em>
            <span>fab fa-periscope</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-phabricator"></em>
            <span>fab fa-phabricator</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-phoenix-framework"></em>
            <span>fab fa-phoenix-framework</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-php"></em>
            <span>fab fa-php</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-pied-piper"></em>
            <span>fab fa-pied-piper</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-pied-piper-alt"></em>
            <span>fab fa-pied-piper-alt</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-pied-piper-pp"></em>
            <span>fab fa-pied-piper-pp</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-pinterest"></em>
            <span>fab fa-pinterest</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-pinterest-p"></em>
            <span>fab fa-pinterest-p</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-pinterest-square"></em>
            <span>fab fa-pinterest-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-playstation"></em>
            <span>fab fa-playstation</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-product-hunt"></em>
            <span>fab fa-product-hunt</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-pushed"></em>
            <span>fab fa-pushed</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-python"></em>
            <span>fab fa-python</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-qq"></em>
            <span>fab fa-qq</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-quinscape"></em>
            <span>fab fa-quinscape</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-quora"></em>
            <span>fab fa-quora</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-ravelry"></em>
            <span>fab fa-ravelry</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-react"></em>
            <span>fab fa-react</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-readme"></em>
            <span>fab fa-readme</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-rebel"></em>
            <span>fab fa-rebel</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-red-river"></em>
            <span>fab fa-red-river</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-reddit"></em>
            <span>fab fa-reddit</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-reddit-alien"></em>
            <span>fab fa-reddit-alien</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-reddit-square"></em>
            <span>fab fa-reddit-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-rendact"></em>
            <span>fab fa-rendact</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-renren"></em>
            <span>fab fa-renren</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-replyd"></em>
            <span>fab fa-replyd</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-resolving"></em>
            <span>fab fa-resolving</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-rocketchat"></em>
            <span>fab fa-rocketchat</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-rockrms"></em>
            <span>fab fa-rockrms</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-safari"></em>
            <span>fab fa-safari</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-sass"></em>
            <span>fab fa-sass</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-schlix"></em>
            <span>fab fa-schlix</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-scribd"></em>
            <span>fab fa-scribd</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-searchengin"></em>
            <span>fab fa-searchengin</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-sellcast"></em>
            <span>fab fa-sellcast</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-sellsy"></em>
            <span>fab fa-sellsy</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-servicestack"></em>
            <span>fab fa-servicestack</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-shirtsinbulk"></em>
            <span>fab fa-shirtsinbulk</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-simplybuilt"></em>
            <span>fab fa-simplybuilt</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-sistrix"></em>
            <span>fab fa-sistrix</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-skyatlas"></em>
            <span>fab fa-skyatlas</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-skype"></em>
            <span>fab fa-skype</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-slack"></em>
            <span>fab fa-slack</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-slack-hash"></em>
            <span>fab fa-slack-hash</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-slideshare"></em>
            <span>fab fa-slideshare</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-snapchat"></em>
            <span>fab fa-snapchat</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-snapchat-ghost"></em>
            <span>fab fa-snapchat-ghost</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-snapchat-square"></em>
            <span>fab fa-snapchat-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-soundcloud"></em>
            <span>fab fa-soundcloud</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-speakap"></em>
            <span>fab fa-speakap</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-spotify"></em>
            <span>fab fa-spotify</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-stack-exchange"></em>
            <span>fab fa-stack-exchange</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-stack-overflow"></em>
            <span>fab fa-stack-overflow</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-staylinked"></em>
            <span>fab fa-staylinked</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-steam"></em>
            <span>fab fa-steam</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-steam-square"></em>
            <span>fab fa-steam-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-steam-symbol"></em>
            <span>fab fa-steam-symbol</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-sticker-mule"></em>
            <span>fab fa-sticker-mule</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-strava"></em>
            <span>fab fa-strava</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-stripe"></em>
            <span>fab fa-stripe</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-stripe-s"></em>
            <span>fab fa-stripe-s</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-studiovinari"></em>
            <span>fab fa-studiovinari</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-stumbleupon"></em>
            <span>fab fa-stumbleupon</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-stumbleupon-circle"></em>
            <span>fab fa-stumbleupon-circle</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-superpowers"></em>
            <span>fab fa-superpowers</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-supple"></em>
            <span>fab fa-supple</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-telegram"></em>
            <span>fab fa-telegram</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-telegram-plane"></em>
            <span>fab fa-telegram-plane</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-tencent-weibo"></em>
            <span>fab fa-tencent-weibo</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-themeisle"></em>
            <span>fab fa-themeisle</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-trello"></em>
            <span>fab fa-trello</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-tripadvisor"></em>
            <span>fab fa-tripadvisor</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-tumblr"></em>
            <span>fab fa-tumblr</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-tumblr-square"></em>
            <span>fab fa-tumblr-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-twitch"></em>
            <span>fab fa-twitch</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-twitter"></em>
            <span>fab fa-twitter</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-twitter-square"></em>
            <span>fab fa-twitter-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-typo3"></em>
            <span>fab fa-typo3</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-uber"></em>
            <span>fab fa-uber</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-uikit"></em>
            <span>fab fa-uikit</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-uniregistry"></em>
            <span>fab fa-uniregistry</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-untappd"></em>
            <span>fab fa-untappd</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-usb"></em>
            <span>fab fa-usb</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-ussunnah"></em>
            <span>fab fa-ussunnah</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-vaadin"></em>
            <span>fab fa-vaadin</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-viacoin"></em>
            <span>fab fa-viacoin</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-viadeo"></em>
            <span>fab fa-viadeo</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-viber"></em>
            <span>fab fa-viber</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-vimeo"></em>
            <span>fab fa-vimeo</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-vimeo-square"></em>
            <span>fab fa-vimeo-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-vimeo-v"></em>
            <span>fab fa-vimeo-v</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-vine"></em>
            <span>fab fa-vine</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-vk"></em>
            <span>fab fa-vk</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-vnv"></em>
            <span>fab fa-vnv</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-vuejs"></em>
            <span>fab fa-vuejs</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-weibo"></em>
            <span>fab fa-weibo</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-weixin"></em>
            <span>fab fa-weixin</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-whatsapp"></em>
            <span>fab fa-whatsapp</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-whatsapp-square"></em>
            <span>fab fa-whatsapp-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-whmcs"></em>
            <span>fab fa-whmcs</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-wikipedia-w"></em>
            <span>fab fa-wikipedia-w</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-windows"></em>
            <span>fab fa-windows</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-wordpress"></em>
            <span>fab fa-wordpress</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-wordpress-simple"></em>
            <span>fab fa-wordpress-simple</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-wpbeginner"></em>
            <span>fab fa-wpbeginner</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-wpexplorer"></em>
            <span>fab fa-wpexplorer</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-wpforms"></em>
            <span>fab fa-wpforms</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-xbox"></em>
            <span>fab fa-xbox</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-xing"></em>
            <span>fab fa-xing</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-xing-square"></em>
            <span>fab fa-xing-square</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-y-combinator"></em>
            <span>fab fa-y-combinator</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-yahoo"></em>
            <span>fab fa-yahoo</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-yandex"></em>
            <span>fab fa-yandex</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-yandex-international"></em>
            <span>fab fa-yandex-international</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-yelp"></em>
            <span>fab fa-yelp</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-yoast"></em>
            <span>fab fa-yoast</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-youtube"></em>
            <span>fab fa-youtube</span>
          </b-col>
          <b-col cols="12" lg="3" md="4" class="my-1 d-flex align-items-center">
            <em class="mr-2 fab fa-youtube-square"></em>
            <span>fab fa-youtube-square</span>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "FontAwesomeIcons",
  data: () => ({
    page: {
      title: "Font Awesome Icons",
    },
  }),
};
</script>